import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Title.css';

const Title = ({ title }) =>
  <div className={s.titleContainer}>
    <div className={s.title}>
      {title}
    </div>
  </div>;

Title.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(Title);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/Title/Title.js